import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadingToRedirect from "./LoadingToRedirect";
import { currentEmployee } from "../function/auth";

const EmployeeRoute = ({ children }) => {
  const { user } = useSelector((state) => ({ ...state }));
  const [ok, setOk] = useState(false);

  useEffect(() => {
    if (user && user.token) {
      currentEmployee(user.token)
        .then((res) => {
          console.log("Employee Verified:", res);
          setOk(true);
        })
        .catch((err) => {
          console.log("Employee Access Denied:", err);
          setOk(false);
        });
    }
  }, [user]);

  return ok ? children : <LoadingToRedirect />;
};

export default EmployeeRoute;
